import { Map as ImmutableMap, List, Record, fromJS } from 'immutable';
import {
  CLEAR_GROUP_ERROR,
  CLEAR_GROUP_ERRORS,
  CLEAR_PAGE,
  CLOSE_FILE_UPLOAD,
  DELETE_CONFIGURATION,
  DOMAIN_OPTIONS_CHANGE,
  FETCH_CA,
  FETCH_DATA,
  FETCH_ROLES,
  GROUP_SEARCH_DATA_CHANGE,
  OPEN_FILE_UPLOAD,
  SAVE_FORM,
  SAVE_GROUP_ERRORS,
} from './constants';

const InitialState = Record({
  ca: new List(),
  dataModified: false,
  configuration: new List(),
  groupData: new List(),
  groupDataLoading: null,
  showFileUpload: false,
  groupErrors: new ImmutableMap(),
  roles: new List(),
});

const transformToFormData = (configurations) => {
  return configurations.map((config) => {
    const serverType = config.get('serverType');
    if (serverType === 'dns') {
      const cert = config.getIn(['server', 'cert']);
      const domain = config.getIn(['server', 'domain']);
      const serviceName = config.getIn(['server', 'serviceName']);
      const useLdaps = config.getIn(['server', 'useLdaps']);
      return config
        .set(
          'cert',
          !List.isList(cert) || cert.size === 0 ? '' : cert.join(';'),
        )
        .set('domain', domain)
        .set('serviceName', serviceName)
        .set('useLdaps', useLdaps)
        .set('server', new List());
    }
    return config.set('serviceName', 'LDAP').set('useLdaps', false);
  });
};

const initialState = new InitialState();

function ldapReducer(state = initialState, action = undefined) {
  switch (action.type) {
    case `${FETCH_DATA}_SUCCESS`: {
      const { configuration } = action.payload;
      return state.set(
        'configuration',
        transformToFormData(fromJS(configuration)),
      );
    }
    case `${FETCH_CA}_SUCCESS`:
      return state.set('ca', fromJS(action.payload.ca || []));
    case DOMAIN_OPTIONS_CHANGE: {
      const { options } = action.payload;
      return Object.keys(action.payload.options).reduce((acc, key) => {
        return acc.set(key, options[key]);
      }, state);
    }
    case `${SAVE_FORM}_SUCCESS`: {
      const { configuration } = action.payload;
      const foundConfigurationIndex = state
        .get('configuration')
        .findIndex((config) => config.get('id') === configuration.get('id'));
      if (foundConfigurationIndex > -1) {
        return state.setIn(
          ['configuration', foundConfigurationIndex],
          configuration,
        );
      }
      return state.update('configuration', (config) =>
        config.push(configuration),
      );
    }
    case `${GROUP_SEARCH_DATA_CHANGE}_START`: {
      return state.set('groupDataLoading', action.payload.index);
    }
    case `${GROUP_SEARCH_DATA_CHANGE}_ERROR`: {
      return state.set('groupDataLoading', null);
    }
    case `${GROUP_SEARCH_DATA_CHANGE}_SUCCESS`: {
      const { result } = action.payload;
      if (state.get('groupDataLoading')) {
        return state
          .set('groupDataLoading', null)
          .set('groupData', new List(result));
      }
      return state;
    }
    case `${DELETE_CONFIGURATION}_SUCCESS`: {
      const { id } = action.payload;
      const foundConfigIndex = state
        .get('configuration')
        .findIndex((config) => config.get('id') === id);
      if (foundConfigIndex > -1) {
        return state.update('configuration', (configuration) =>
          configuration.delete(foundConfigIndex),
        );
      }
      return state;
    }
    case CLOSE_FILE_UPLOAD: {
      return state.set('showFileUpload', false);
    }
    case OPEN_FILE_UPLOAD: {
      return state.set('showFileUpload', true);
    }
    case CLEAR_PAGE:
      return new InitialState();
    case SAVE_GROUP_ERRORS:
      return state.set('groupErrors', action.payload.errors);
    case CLEAR_GROUP_ERROR: {
      const { index } = action.payload;
      if (state.getIn(['groupErrors', String(index)])) {
        return state.update('groupErrors', (errors) =>
          errors.delete(String(index)),
        );
      }
      return state;
    }
    case CLEAR_GROUP_ERRORS:
      if (state.get('groupErrors').size) {
        return state.set('groupErrors', new ImmutableMap());
      }
      return state;
    case `${FETCH_ROLES}_SUCCESS`: {
      return state.set('roles', new List(action.payload.roles));
    }
    case `${FETCH_ROLES}_ERROR`: {
      return state.set('roles', new List([]));
    }
    default:
      return state;
  }
}

export default ldapReducer;
